import { createSelector } from 'reselect';

const getProductDetails = (state) => state.productDetails || {};

const breadCrumbInfo = createSelector(
    [getProductDetails],
    (productDetails) => productDetails.breadCrumbInfo
);

export default breadCrumbInfo;
